// Reports Tab - GetForecastReportsWithPagination
export const FETCH_FORECAST_REPORTS_TAB_REQUEST = 'FETCH_FORECAST_REPORTS_TAB_REQUEST';
export const FETCH_FORECAST_REPORTS_TAB_SUCCESS = 'FETCH_FORECAST_REPORTS_TAB_SUCCESS';
export const FETCH_FORECAST_REPORTS_TAB_FAILURE = 'FETCH_FORECAST_REPORTS_TAB_FAILURE';

// Delete Forecast Reports Tab - DeleteForecastReports
export const DELETE_FORECAST_REPORTS_REQUEST = 'DELETE_FORECAST_REPORTS_REQUEST';
export const DELETE_FORECAST_REPORTS_SUCCESS = 'DELETE_FORECAST_REPORTS_SUCCESS';
export const DELETE_FORECAST_REPORTS_FAILURE = 'DELETE_FORECAST_REPORTS_FAILURE';

// Notes Edit Actions
export const FETCH_FORECAST_NOTES_EDIT_REQUEST = 'FETCH_FORECAST_NOTES_EDIT_REQUEST';
export const FETCH_FORECAST_NOTES_EDIT_SUCCESS = 'FETCH_FORECAST_NOTES_EDIT_SUCCESS';
export const FETCH_FORECAST_NOTES_EDIT_FAILURE = 'FETCH_FORECAST_NOTES_EDIT_FAILURE';

// Notes Save Actions
export const FETCH_FORECAST_NOTES_SAVE_REQUEST = 'FETCH_FORECAST_NOTES_SAVE_REQUEST'; 
export const FETCH_FORECAST_NOTES_SAVE_SUCCESS = 'FETCH_FORECAST_NOTES_SAVE_SUCCESS';
export const FETCH_FORECAST_NOTES_SAVE_FAILURE = 'FETCH_FORECAST_NOTES_SAVE_FAILURE';

// Dropdowns Actions
export const GET_ALL_FORECASTING_DEMAND_DROPDOWNS_REQUEST = 'GET_ALL_FORECASTING_DEMAND_DROPDOWNS_REQUEST';
export const GET_ALL_FORECASTING_DEMAND_DROPDOWNS_SUCCESS = 'GET_ALL_FORECASTING_DEMAND_DROPDOWNS_SUCCESS';
export const GET_ALL_FORECASTING_DEMAND_DROPDOWNS_FAILURE = 'GET_ALL_FORECASTING_DEMAND_DROPDOWNS_FAILURE';

// Get Forecasting Demand By Id With Pagination Actions
export const GET_FORECASTING_DEMAND_BY_ID_WITH_PAGINATION_REQUEST = 'GET_FORECASTING_DEMAND_BY_ID_WITH_PAGINATION_REQUEST';
export const GET_FORECASTING_DEMAND_BY_ID_WITH_PAGINATION_SUCCESS = 'GET_FORECASTING_DEMAND_BY_ID_WITH_PAGINATION_SUCCESS';
export const GET_FORECASTING_DEMAND_BY_ID_WITH_PAGINATION_FAILURE = 'GET_FORECASTING_DEMAND_BY_ID_WITH_PAGINATION_FAILURE';

export const GET_FORECAST_DEMAND_SITE_PRIORITY_DRILLTHROUGH_REQUEST = 'GET_FORECAST_DEMAND_SITE_PRIORITY_DRILLTHROUGH_REQUEST';
export const GET_FORECAST_DEMAND_SITE_PRIORITY_DRILLTHROUGH_SUCCESS = 'GET_FORECAST_DEMAND_SITE_PRIORITY_DRILLTHROUGH_SUCCESS';
export const GET_FORECAST_DEMAND_SITE_PRIORITY_DRILLTHROUGH_FAILURE = 'GET_FORECAST_DEMAND_SITE_PRIORITY_DRILLTHROUGH_FAILURE';

// Save Forecasting Demand Reports Actions
export const SAVE_FORECASTING_DEMAND_REPORTS_REQUEST = 'SAVE_FORECASTING_DEMAND_REPORTS_REQUEST';
export const SAVE_FORECASTING_DEMAND_REPORTS_SUCCESS = 'SAVE_FORECASTING_DEMAND_REPORTS_SUCCESS';
export const SAVE_FORECASTING_DEMAND_REPORTS_FAILURE = 'SAVE_FORECASTING_DEMAND_REPORTS_FAILURE';

// Common update reducer
export const UPDATE_FORECAST_REDUCER = 'UPDATE_FORECAST_REDUCER';

// Demand Table Tab
export const FETCH_FORECAST_FILTER_DROPDOWNS_REQUEST = 'FETCH_FORECAST_FILTER_DROPDOWNS_REQUEST';
export const FETCH_FORECAST_FILTER_DROPDOWNS_SUCCESS = 'FETCH_FORECAST_FILTER_DROPDOWNS_SUCCESS';
export const FETCH_FORECAST_FILTER_DROPDOWNS_FAILURE = 'FETCH_FORECAST_FILTER_DROPDOWNS_FAILURE';
